var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scroll-board"}},[_c('dv-border-box-6',[_c('div',{staticClass:"table-name",staticStyle:{"text-align":"center","padding-top":"8px"}},[_c('img',{attrs:{"src":require("./img/icon6.png")}}),_vm._v("操作记录信息\n    ")]),_c('dv-scroll-board',{staticStyle:{"margin-top":"-1px"},attrs:{"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }